export const BeanRegistry = new Map<string, any>();